/* In the Thumbnails / Thumbnail carousel desktop layouts, Dawn hides every
   non-active slide (display:none), which leaves only one slide with any
   width. Dawn's own slider-component prev/next buttons scroll based on the
   offset between two visible slides, so with only one visible slide that
   math produces NaN and the buttons do nothing. This drives the same
   prev/next buttons by clicking the corresponding thumbnail instead, which
   already has working next/prev-photo behavior via media-gallery.js. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!thumbnails || !viewer) return;

    const allItems = Array.from(thumbnails.querySelectorAll('[data-target]'));
    const prevButtons = viewer.querySelectorAll('.slider-buttons .slider-button--prev');
    const nextButtons = viewer.querySelectorAll('.slider-buttons .slider-button--next');
    const currentPageElements = viewer.querySelectorAll('.slider-counter--current');
    const pageTotalElements = viewer.querySelectorAll('.slider-counter--total');
    if (!allItems.length || (!prevButtons.length && !nextButtons.length)) return;

    // When a product has variant-specific photos, Dawn only ever shows one of
    // them at a time (`.thumbnail-list_item--variant:not(:first-child) {
    // display: none }`) — the rest stay in the DOM as hidden `[data-target]`
    // thumbnails. Counting/stepping through the raw querySelectorAll result
    // therefore overcounts (an "X/3" total for only 2 visible photos) and can
    // land on a hidden thumbnail whose slide never displays, leaving the
    // viewer blank. Re-filtering to only the currently visible thumbnails on
    // every call keeps this correct even as variant selection changes which
    // thumbnail is the visible one.
    //
    // Checked via each item's own `display`, not `offsetParent` — offsetParent
    // is null for ANY ancestor being hidden, not just this item. On mobile the
    // whole thumbnail strip can be display:none (mobile_thumbnails: "hide"),
    // which made offsetParent null for every thumbnail regardless of variant
    // state, producing a permanent "0 / 0" counter instead of the real count.
    const visibleItems = () => allItems.filter((item) => getComputedStyle(item).display !== 'none');

    const activeIndex = (items) => items.findIndex((item) => item.querySelector('button').hasAttribute('aria-current'));

    // Dawn's own counter text only updates via slider-component's scroll-offset
    // math, which never runs here (see note above), so it's kept in sync here instead.
    const refresh = () => {
      const items = visibleItems();
      const index = activeIndex(items);
      currentPageElements.forEach((element) => { element.textContent = index + 1; });
      pageTotalElements.forEach((element) => { element.textContent = items.length; });
    };

    const step = (direction) => {
      const items = visibleItems();
      const index = activeIndex(items);
      const delta = direction === 'next' ? 1 : -1;
      const nextIndex = (index + delta + items.length) % items.length;
      items[nextIndex].querySelector('button').click();
      refresh();
    };

    prevButtons.forEach((button) => button.addEventListener('click', () => step('prev')));
    nextButtons.forEach((button) => button.addEventListener('click', () => step('next')));
    allItems.forEach((item) => item.querySelector('button').addEventListener('click', refresh));

    refresh();
  });
});
